/* The Glow Up Guide — Free itinerary. Reveal-on-scroll + offset-aware scroll to the capture form. Theme-editor safe. */
(function(){
  document.documentElement.classList.add('gugf-js');

  function reveal(root){
    var design = window.Shopify && window.Shopify.designMode;
    var items = root.querySelectorAll('.gugf-reveal');
    if(design || !('IntersectionObserver' in window)){
      items.forEach(function(el){ el.classList.add('gugf-in'); });
      return;
    }
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('gugf-in'); io.unobserve(e.target); } });
    }, { threshold:.14, rootMargin:'0px 0px -40px 0px' });
    items.forEach(function(el){ io.observe(el); });
  }

  // Intrinsic header height so jumps land below a sticky / auto-hide header.
  function topInset(){
    var sels = ['#shopify-section-header','sticky-header','.header-wrapper','.site-header','.section-header','.header__wrapper','header'];
    for(var i=0;i<sels.length;i++){
      var el = document.querySelector(sels[i]);
      if(el){ var h = el.offsetHeight; if(h > 0 && h < 300) return h; }
    }
    return 0;
  }
  function setScrollMargins(){
    var off = topInset() + 20;
    document.querySelectorAll('.gugf-capture').forEach(function(el){ el.style.scrollMarginTop = off + 'px'; });
  }
  function scrollToForm(el){
    var off = topInset() + 20;
    var top = el.getBoundingClientRect().top + window.pageYOffset - off;
    if(top < 0) top = 0;
    try{ window.scrollTo({ top: top, behavior:'smooth' }); }catch(e){ window.scrollTo(0, top); }
  }

  // Delegated jump-to-form for the header / sticky / closing CTAs.
  document.addEventListener('click', function(e){
    var a = e.target.closest ? e.target.closest('[data-gugf-join]') : null;
    if(!a) return;
    e.preventDefault();
    var el = document.getElementById(a.getAttribute('data-gugf-join'));
    if(el){ setScrollMargins(); scrollToForm(el); }
  });

  function init(root){
    var scope = root || document;
    reveal(scope);
    setScrollMargins();
    // after a successful signup the page reloads with the success card; bring it into view
    var ok = scope.querySelector('.gugf-ok');
    if(ok){ var card = ok.closest('.gugf-capture') || ok; scrollToForm(card); }
  }

  if(document.readyState !== 'loading'){ init(document); }
  else { document.addEventListener('DOMContentLoaded', function(){ init(document); }); }

  window.addEventListener('resize', setScrollMargins);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
